// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32BVV","toggle":"styles_toggle__1SPwu","preview":"styles_preview__bK902"};